module.exports = __webpack_public_path__ + "static/img/newsDetailPic7.efdc278.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newsDetailPic7.png
// module id = Q6Sg
// module chunks = 1